import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TwitchOutlinedSvg from "@ant-design/icons-svg/es/asn/TwitchOutlined";
import AntdIcon from "../components/AntdIcon";
var TwitchOutlined = function TwitchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TwitchOutlinedSvg
  }));
};

/**![twitch](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTY2LjEzIDExMkwxMTQgMjUxLjE3djU1Ni40NmgxOTEuMlY5MTJoMTA0LjRsMTA0LjIzLTEwNC40aDE1Ni41TDg3OSA1OTlWMTEyem02OS41NCA2OS41SDgwOS41djM4Mi42M0w2ODcuNzcgNjg1Ljg3SDQ5Ni41TDM5Mi4yNyA3OTAuMVY2ODUuODdoLTE1Ni42ek00MjcgNTI5LjRoNjkuNVYzMjAuNzNINDI3em0xOTEuMTcgMGg2OS41M1YzMjAuNzNoLTY5LjUzeiIgLz48L3N2Zz4=) */
var RefIcon = /*#__PURE__*/React.forwardRef(TwitchOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'TwitchOutlined';
}
export default RefIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/TwitchOutlined.js
// module id = 3450
// module chunks = 0